export default __webpack_public_path__ + "static/media/icon-mute2.0ccd589f.svg";